import type React from 'react';
import Responsive from 'react-responsive';
import { styled } from 'styled-components';

import { Sizes } from '../../theme/Media.tsx';
import { useTableContext } from './context.tsx';
import Td, { Wrapper as TdWrapper } from './Td.tsx';
import Tr from './Tr.tsx';

export const Separator = styled.tbody`
  &:first-child,
  &:last-child {
    display: none;
  }
  ${TdWrapper} {
    padding: 3px 0;
  }
  & + & {
    ${TdWrapper} {
      padding: 2px 0;
    }
  }
`;

const TbodySeparator: React.FC = () => {
  const { isCollapsedNav } = useTableContext();
  return (
    <Responsive minWidth={isCollapsedNav ? Sizes.lgMin : Sizes.xlgMin}>
      <Separator>
        <Tr>
          <Td type='sub' bgColor='transparent' />
        </Tr>
      </Separator>
    </Responsive>
  );
};

export default TbodySeparator;
